export default __webpack_public_path__ + "static/media/vision fbc.75f742e5.png";